import { DashboardAnalyticsAll, IsLoading, SocialShare } from "./dashboardAnalytics"
import http from '../../../config/BaseUrl'

export const getAllDashboardAnalytics = () => async (dispatch) => {
    try {
        dispatch(IsLoading())
        await http.get("dashboard-analytics").then((res) => {
            dispatch(DashboardAnalyticsAll(res.data))
        }).catch((err) => err.data.message)
    } catch (error) {
        
    }
}

export const AllSocialShare = () => async (dispatch) => {
    try {
        dispatch(IsLoading())
        await http.get("social-share").then((res) => {
            dispatch(SocialShare(res.data))
        }).catch((err) => err.data.message)
    } catch (error) {
        
    }
}